import React from 'react';
import SearchInput from '../SearchInput';
import { producaov2 } from '../../../../../services/apis';

const userRequest = async (search) => {
  const response = await producaov2.get(`alunos?search=${search}&limit=15`);
  return response.data?.map(user => ({id: user?.id, name: `[${user?.id}] ${user?.email}`}));
}

export default function UserSearch({ selectedUser, onChangeSelectedUser, errorMessage }) {
  return (
    <SearchInput
      label="Selecione um aluno"
      searchRequest={userRequest}
      selectedOption={selectedUser}
      onChangeSelectedOption={onChangeSelectedUser}
      errorMessage={errorMessage}
    />
  );
}